import { apiClient } from '@/shared/api';
import { API_ENDPOINTS } from '@/config';
import type {
    CardBatch,
    GenericResponse,
    CardBatchListResponse,
} from '@/features/card/types/card.types';
import { buildCommonHeaders } from '@/shared/http/commonHeaders';

export const batchService = {
    async getCardBatchDetail(suitcase_uuid: string): Promise<CardBatch> {

        const newHeaders = buildCommonHeaders({
            withLocation: true
        });

        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.batch.get + `/${suitcase_uuid}`, {}, { headers: newHeaders });
        return response.data.data;
    },

    async getCardBatchList(page: number, limit: number): Promise<CardBatchListResponse> {

        const newHeaders = buildCommonHeaders({
            withLocation: true
        });

        const response = await apiClient.post<GenericResponse>(API_ENDPOINTS.batch.list, { params: { page, limit } }, { headers: newHeaders });
        return response.data.data;
    },

    async confirmBatch(suitcase_uuid: string): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.batch.confirm(suitcase_uuid), {}, { headers: newHeaders });
    },

    async createBatch(payload: any): Promise<GenericResponse> {
        const newHeaders = buildCommonHeaders({ withLocation: true });
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve({
                    data: {},
                    response: 'OK'
                });
            }, 100);
        });
        return apiClient.post<GenericResponse>(API_ENDPOINTS.batch.create, payload, { headers: newHeaders });
    },
};
